import type { AgendaModule } from "@repo/types";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { AgendaModuleCopyForm } from "./AgendaModuleCopyForm";
import { AGENDA_MODULE_MOTIF } from "@/lib/constants";

export const AgendaModuleCopyDialog = ({
  tenantId,
  template,
  open: outerOpen,
  setOpen: outerSetOpen,
}: {
  tenantId: string;
  template: AgendaModule;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}) => {
  const [innerOpen, innerSetOpen] = useState(false);

  const open = outerOpen ?? innerOpen;
  const setOpen = outerSetOpen ?? innerSetOpen;

  const handleOpenChange = () => setOpen(!open);

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent preventClickout preventEscape>
        <DialogHeader className={AGENDA_MODULE_MOTIF}>
          <DialogTitle>Select team</DialogTitle>
        </DialogHeader>
        <AgendaModuleCopyForm
          tenantId={tenantId}
          template={template}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
